import {
  ConditionCategory,
  ConditionWizardCategory,
  ServerAbstractType,
  ServerPredicateFilterConditionType,
  ServerPredicateStyleConditionType,
} from './conditions.types';
import createIconsObj from '../../assets/icons/utils/createIconsObj';

const serverPredicateStyleCondition: ServerAbstractType = {
  condition: ServerPredicateStyleConditionType.Condition,
  operator: ServerPredicateStyleConditionType.Operator,
};

const serverPredicateFilterCondition: ServerAbstractType = {
  condition: ServerPredicateFilterConditionType.Condition,
  operator: ServerPredicateFilterConditionType.Operator,
};

const conditionCategoriesIcons: Record<ConditionCategory, string> = {
  [ConditionCategory.Weather]: '/weather.svg',
  [ConditionCategory.WeatherForecast]: '/weather-forecast.svg',
  [ConditionCategory.CurrentWeather]: '/current-weather.svg',
  [ConditionCategory.WeatherForecastDay1]: '/weather-day.svg',
  [ConditionCategory.WeatherForecastDay2]: '/weather-day.svg',
  [ConditionCategory.WeatherForecastDay3]: '/weather-day.svg',
  [ConditionCategory.WeatherForecastDay4]: '/weather-day.svg',
  [ConditionCategory.WeatherForecastDay5]: '/weather-day.svg',
  [ConditionCategory.Sport]: '/sports.svg',
  [ConditionCategory.Location]: '/location.svg',
  [ConditionCategory.Product]: '/product.svg',
  [ConditionCategory.Dsp]: '/dsp.svg',
  [ConditionCategory.Placement]: '/placement.svg',
  [ConditionCategory.User]: '/user.svg',
  [ConditionCategory.Adset]: '/placement.svg',
  [ConditionCategory.Baseball]: '/sports/baseball.svg',
  [ConditionCategory.Soccer]: '/sports/soccer.svg',
  [ConditionCategory.Basketball]: '/sports/basketball.svg',
  [ConditionCategory.AmericanFootball]: '/sports/americanFootball.svg',
  [ConditionCategory.Hockey]: '/sports/hockey.svg',
  [ConditionCategory.Teams]: '/sports/teams.svg',
  [ConditionCategory.Events]: '/sports/events.svg',
  [ConditionCategory.Players]: '/sports/player.svg',
  [ConditionCategory.Olympics]: '/sports/olympics.svg',
  [ConditionCategory.Medals]: '/sports/medals.svg',
  [ConditionCategory.Ecommerce]: '/products/ecommerce.svg',
  [ConditionCategory.Flight]: '/products/flights.svg',
  [ConditionCategory.Hotel]: '/products/hotel.svg',
  [ConditionCategory.Package]: '/products/package.svg',
  [ConditionCategory.Car_rental]: '/products/car_rental.svg',
  [ConditionCategory.Car]: '/products/car.svg',
  [ConditionCategory.Activity]: '/products/activity.svg',
  [ConditionCategory.CPG]: '/products/cpg.svg',
  [ConditionCategory.Content]: '/products/content.svg',
} as const;

const conditionCategoriesIconsObj = createIconsObj(
  conditionCategoriesIcons,
  'conditions_wizard/categories',
);

const defaultSubCategories: ConditionWizardCategory[] = [];
const conditionCategoryData: Record<ConditionCategory, ConditionWizardCategory> = {
  [ConditionCategory.Olympics]: {
    value: ConditionCategory.Olympics,
    title: 'Olympics',
    icon: conditionCategoriesIconsObj[ConditionCategory.Olympics],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Medals]: {
    value: ConditionCategory.Medals,
    title: 'Medals',
    icon: conditionCategoriesIconsObj[ConditionCategory.Medals],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Weather]: {
    value: ConditionCategory.Weather,
    title: 'Weather',
    icon: conditionCategoriesIconsObj[ConditionCategory.Weather],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Sport]: {
    value: ConditionCategory.Sport,
    title: 'Sport',
    icon: conditionCategoriesIconsObj[ConditionCategory.Sport],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Location]: {
    value: ConditionCategory.Location,
    title: 'Location',
    icon: conditionCategoriesIconsObj[ConditionCategory.Location],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Product]: {
    value: ConditionCategory.Product,
    title: 'Product',
    icon: conditionCategoriesIconsObj[ConditionCategory.Product],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Dsp]: {
    value: ConditionCategory.Dsp,
    title: 'DSP',
    icon: conditionCategoriesIconsObj[ConditionCategory.Dsp],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Placement]: {
    value: ConditionCategory.Placement,
    title: 'Placement',
    icon: conditionCategoriesIconsObj[ConditionCategory.Placement],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Adset]: {
    value: ConditionCategory.Adset,
    title: 'Adset',
    icon: conditionCategoriesIconsObj[ConditionCategory.Adset],
    categories: defaultSubCategories,
  },
  [ConditionCategory.User]: {
    value: ConditionCategory.User,
    title: 'User',
    icon: conditionCategoriesIconsObj[ConditionCategory.User],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Baseball]: {
    value: ConditionCategory.Baseball,
    title: 'Baseball',
    icon: conditionCategoriesIconsObj[ConditionCategory.Baseball],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Soccer]: {
    value: ConditionCategory.Soccer,
    title: 'Soccer',
    icon: conditionCategoriesIconsObj[ConditionCategory.Soccer],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Basketball]: {
    value: ConditionCategory.Basketball,
    title: 'Basketball',
    icon: conditionCategoriesIconsObj[ConditionCategory.Basketball],
    categories: defaultSubCategories,
  },
  [ConditionCategory.AmericanFootball]: {
    value: ConditionCategory.AmericanFootball,
    title: 'American Football',
    icon: conditionCategoriesIconsObj[ConditionCategory.AmericanFootball],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Hockey]: {
    value: ConditionCategory.Hockey,
    title: 'Hockey',
    icon: conditionCategoriesIconsObj[ConditionCategory.Hockey],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Teams]: {
    value: ConditionCategory.Teams,
    title: 'Teams',
    icon: conditionCategoriesIconsObj[ConditionCategory.Teams],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Events]: {
    value: ConditionCategory.Events,
    title: 'Events',
    icon: conditionCategoriesIconsObj[ConditionCategory.Events],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Players]: {
    value: ConditionCategory.Players,
    title: 'Players',
    icon: conditionCategoriesIconsObj[ConditionCategory.Players],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Ecommerce]: {
    value: ConditionCategory.Ecommerce,
    title: 'Ecommerce',
    icon: conditionCategoriesIconsObj[ConditionCategory.Ecommerce],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Flight]: {
    value: ConditionCategory.Flight,
    title: 'Flight',
    icon: conditionCategoriesIconsObj[ConditionCategory.Flight],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Hotel]: {
    value: ConditionCategory.Hotel,
    title: 'Hotel',
    icon: conditionCategoriesIconsObj[ConditionCategory.Hotel],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Package]: {
    value: ConditionCategory.Package,
    title: 'Package',
    icon: conditionCategoriesIconsObj[ConditionCategory.Package],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Car_rental]: {
    value: ConditionCategory.Car_rental,
    title: 'Car Rental',
    icon: conditionCategoriesIconsObj[ConditionCategory.Car_rental],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Car]: {
    value: ConditionCategory.Car,
    title: 'Car',
    icon: conditionCategoriesIconsObj[ConditionCategory.Car],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Activity]: {
    value: ConditionCategory.Activity,
    title: 'Activity',
    icon: conditionCategoriesIconsObj[ConditionCategory.Activity],
    categories: defaultSubCategories,
  },
  [ConditionCategory.CPG]: {
    value: ConditionCategory.CPG,
    title: 'CPG',
    icon: conditionCategoriesIconsObj[ConditionCategory.CPG],
    categories: defaultSubCategories,
  },
  [ConditionCategory.CurrentWeather]: {
    value: ConditionCategory.CurrentWeather,
    title: 'Current',
    icon: conditionCategoriesIconsObj[ConditionCategory.CurrentWeather],
    categories: defaultSubCategories,
  },
  [ConditionCategory.WeatherForecast]: {
    value: ConditionCategory.WeatherForecast,
    title: 'Forecast',
    icon: conditionCategoriesIconsObj[ConditionCategory.WeatherForecast],
    categories: defaultSubCategories,
  },
  [ConditionCategory.WeatherForecastDay1]: {
    value: ConditionCategory.WeatherForecastDay1,
    title: 'Day 1 (Today)',
    icon: conditionCategoriesIconsObj[ConditionCategory.WeatherForecastDay1],
    categories: defaultSubCategories,
  },
  [ConditionCategory.WeatherForecastDay2]: {
    value: ConditionCategory.WeatherForecastDay2,
    title: 'Day 2 (Tomorrow)',
    icon: conditionCategoriesIconsObj[ConditionCategory.WeatherForecastDay2],
    categories: defaultSubCategories,
  },
  [ConditionCategory.WeatherForecastDay3]: {
    value: ConditionCategory.WeatherForecastDay3,
    title: 'Day 3',
    icon: conditionCategoriesIconsObj[ConditionCategory.WeatherForecastDay3],
    categories: defaultSubCategories,
  },
  [ConditionCategory.WeatherForecastDay4]: {
    value: ConditionCategory.WeatherForecastDay4,
    title: 'Day 4',
    icon: conditionCategoriesIconsObj[ConditionCategory.WeatherForecastDay4],
    categories: defaultSubCategories,
  },
  [ConditionCategory.WeatherForecastDay5]: {
    value: ConditionCategory.WeatherForecastDay5,
    title: 'Day 5',
    icon: conditionCategoriesIconsObj[ConditionCategory.WeatherForecastDay5],
    categories: defaultSubCategories,
  },
  [ConditionCategory.Content]: {
    value: ConditionCategory.Content,
    title: 'Content',
    icon: conditionCategoriesIconsObj[ConditionCategory.Content],
    categories: defaultSubCategories,
  },
};

const PROFILE_AUDIENCES_CONDITION_KEY = 'profile.audiences';
const PROFILE_TAGS_CONDITION_KEY = 'profile.taggingAdapter.tags';

export {
  serverPredicateStyleCondition,
  serverPredicateFilterCondition,
  conditionCategoryData,
  PROFILE_AUDIENCES_CONDITION_KEY,
  PROFILE_TAGS_CONDITION_KEY,
};
